import { useState } from 'react';
import { Mail, MessageCircle, X } from 'lucide-react';

export function FloatingSupport() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-40">
      {/* Support Menu */}
      <div
        className={`absolute bottom-20 right-0 transition-all duration-300 origin-bottom-right ${
          isOpen
            ? 'opacity-100 scale-100 pointer-events-auto'
            : 'opacity-0 scale-95 pointer-events-none'
        }`}
      >
        <div className="bg-white rounded-lg shadow-xl p-3 border border-gray-200 min-w-max">
          <a
            href="https://chat.whatsapp.com/FDEpAAdwm5kAsd1KcgHSsg?s=cl&p=i&mlu=0&ilr=0&amv=2"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-4 py-2 text-pesajet-700 hover:bg-pesajet-50 rounded-md transition-colors whitespace-nowrap text-sm font-medium"
          >
            <img src="/whatsapp.svg" alt="WhatsApp" className="w-5 h-5" />
            <span>WhatsApp</span>
          </a>
          <a
            href="mailto:support@pesajet.com"
            className="flex items-center gap-2 px-4 py-2 text-pesajet-700 hover:bg-pesajet-50 rounded-md transition-colors whitespace-nowrap text-sm font-medium"
          >
            <Mail className="w-5 h-5" />
            <span>Email</span>
          </a>
        </div>
      </div>

      {/* Floating Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="relative flex items-center justify-center w-14 h-14 bg-pesajet-700 hover:bg-pesajet-800 text-white rounded-full shadow-lg transition-all duration-300 hover:scale-110 active:scale-95"
        aria-label="Open support menu"
        aria-expanded={isOpen}
      >
        <MessageCircle
          className={`w-6 h-6 transition-all duration-300 ${
            isOpen ? 'opacity-0 scale-0 absolute' : 'opacity-100 scale-100'
          }`}
        />
        <X
          className={`w-6 h-6 transition-all duration-300 ${
            isOpen ? 'opacity-100 scale-100' : 'opacity-0 scale-0 absolute'
          }`}
        />
      </button>
    </div>
  );
}
